import { QueryBuilderTokenType } from '../../../../types';
import { getInputContext } from '../getInputContext';

export const canOpenBracket = (tokens: QueryBuilderTokenType[]): boolean =>
  getInputContext(tokens) === 'expectOperand';
